interface CityLabelProps {
  province: string;
  cities: string[];
  color: string;
}

const CityLabel = ({ province, cities, color }: CityLabelProps) => {
  return (
    <article
      className="commitment-cityLabel"
      style={{
        backgroundColor: `${color}30`,
        borderLeft: `0.5rem solid ${color}`,
      }}
    >
      <h3 className="province" style={{ color: color }}>
        {province}
      </h3>
      <ul>
        {cities.map((city) => (
          <li key={city}>
            <h4 className="city">{city}</h4>
          </li>
        ))}
      </ul>
    </article>
  );
};

export default CityLabel;
